import { getEnvironment } from 'toolkit/environment/environment/environment.util';
import { buildInfo } from 'toolkit/environment/build-info';
import { FlexContainer } from '../../containers/ContentContainers/FlexContainer';
import { Box, Link } from '@mui/material';

interface BuildInfoProps {
  onClick: () => void;
}

export const BuildInfo = ({ onClick }: BuildInfoProps) => {
  const feBuildTime =
    buildInfo.dateTime === 'local'
      ? 'local'
      : new Date(buildInfo.dateTime).toLocaleString();
  const feGitHash = buildInfo.gitHash;

  const beBuildTime =
    getEnvironment().backendBuildInfo.dateTime === 'local'
      ? 'local'
      : new Date(getEnvironment().backendBuildInfo.dateTime).toLocaleString();
  const beGitHash = getEnvironment().backendBuildInfo.gitHash;

  const displayServerBuildInfo = feGitHash !== beGitHash;

  return (
    <Box>
      <Link
        variant="bodySmall"
        align="center"
        underline="hover"
        onClick={onClick}
      >
        <FlexContainer
          direction="column"
          alignItems="baseline"
          padding="8px 0 0"
          gap={0.5}
          sx={{ cursor: 'pointer' }}
        >
          <Box>{`Build: ${feBuildTime}`}</Box>
          {displayServerBuildInfo && (
            <Box>{`Server build: ${beBuildTime}`}</Box>
          )}
        </FlexContainer>
      </Link>
    </Box>
  );
};
